// import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import axios from 'axios';
// import {
//   Container, Card, Table, Button, Alert, Spinner,
//   InputGroup, Form, Row, Col, Pagination
// } from 'react-bootstrap';
// import { URL } from '../../../config';
// import './ServitorReferral.css';


// const DEFAULT_LIMIT = 10;

// export default function ServitorReferral() {
//   const navigate = useNavigate();
//   const [rows,      setRows]      = useState([]);
//   const [error,     setError]     = useState('');
//   const [loading,   setLoading]   = useState(false);
//   const [searchTerm,setSearchTerm]= useState('');
//   const [meta,      setMeta]      = useState({
//     page:1, limit:DEFAULT_LIMIT, total:0, totalPages:1,
//     search:'', sortBy:'id', sortDir:'ASC'
//   });

//   const token = localStorage.getItem('adminToken');

//   const fetchPage = async () => {
//     setLoading(true);
//     try {
//       const { data } = await axios.get(`${URL}/admin/servitor-referral`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           page : meta.page,
//           limit: DEFAULT_LIMIT,
//           search: searchTerm,
//           sortBy: meta.sortBy,
//           sortDir: meta.sortDir
//         }
//       });
//       setRows(Array.isArray(data?.data) ? data.data : []);
//       if (data.meta) setMeta(m => ({ ...m, ...data.meta }));
//       setError('');
//     } catch (err) {
//       setError('Failed to load referral metrics.');
//       setRows([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPage();
//     // eslint-disable-next-line
//   }, [meta.page, meta.sortBy, meta.sortDir, searchTerm]);

//   const handlePageChange = (pageNumber) => {
//     setMeta(m => ({ ...m, page: pageNumber }));
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3)/2);
//     let start = Math.max(2, current - siblings);
//     let end   = Math.min(total - 1, current + siblings);
//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));
//     if (start > 2) pages.push('start-ellipsis');
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push('end-ellipsis');
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   return (
//     <Container fluid className="servitorreferral-container">
//       <Card className="servitorreferral-card">
//         <Card.Body>
//           <Card.Header className="servitorreferral-header">
//             <h4 className="servitorreferral-title">Servitor Referral Metrics</h4>
//           </Card.Header>

//           {error && <Alert variant="danger">{error}</Alert>}

//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Servitor ID, Name, Mobile, Code"
//                   value={searchTerm}
//                   onChange={e => {
//                     setSearchTerm(e.target.value);
//                     setMeta(m => ({ ...m, page:1 }));
//                   }}
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Button onClick={() => {
//                 setMeta(m => ({ ...m, sortBy:'totalEarned', sortDir: m.sortDir==='ASC'?'DESC':'ASC', page:1 }));
//               }}>
//                 Sort by Earnings {meta.sortBy==='totalEarned' ? (meta.sortDir==='ASC'?'↑':'↓') : ''}
//               </Button>
//             </Col>
//           </Row>

//           {loading ? (
//             <div className="text-center"><Spinner animation="border" /></div>
//           ) : (
//             <Table striped bordered hover responsive className="servitorreferral-table">
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Servitor ID</th>
//                   <th>Name</th>
//                   <th>Mobile</th>
//                   <th>Referral Code</th>
//                   <th>Invited</th>
//                   <th>Qualified</th>
//                   <th>Total Earned</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.map((s,i) => (
//                   <tr key={s.id}>
//                     <td>{i + 1 + (meta.page-1)*meta.limit}</td>
//                     <td>{s.id}</td>
//                     <td>{s.name}</td>
//                     <td>{s.mobile}</td>
//                     <td>{s.referralCode}</td>
//                     <td>{s.invitedCount}</td>
//                     <td>{s.qualifiedCount}</td>
//                     <td>৳{s.totalEarned.toLocaleString()}</td>
//                     <td>
//                       <Button size="sm" variant="outline-primary"
//                         onClick={() => navigate(`/admin/servitor-referral/${s.id}`)}>
//                         Details
//                       </Button>
//                     </td>
//                   </tr>
//                 ))}
//                 {rows.length===0 && (
//                   <tr><td colSpan={9} className="text-center">No data found.</td></tr>
//                 )}
//               </tbody>
//             </Table>
//           )}

//           <Pagination>
//             <Pagination.First onClick={() => handlePageChange(1)} disabled={meta.page===1} />
//             <Pagination.Prev onClick={() => handlePageChange(meta.page-1)} disabled={meta.page===1} />
//             {getPageItems(meta.totalPages, meta.page).map((item, idx) => item==='start-ellipsis' || item==='end-ellipsis' ?
//               <Pagination.Ellipsis key={item+idx} disabled /> :
//               <Pagination.Item key={item} active={item===meta.page}
//                 onClick={()=>handlePageChange(item)}>{item}</Pagination.Item>
//             )}
//             <Pagination.Next onClick={()=>handlePageChange(meta.page+1)}
//               disabled={meta.page===meta.totalPages} />
//             <Pagination.Last onClick={()=>handlePageChange(meta.totalPages)}
//               disabled={meta.page===meta.totalPages} />
//           </Pagination>

//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }





// Upper code okay, Updated for auth protect (2-Dec-2025) ***** //
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import {
  Container, Card, Table, Button, Alert, Spinner,
  InputGroup, Form, Row, Col, Pagination
} from 'react-bootstrap';
import { URL } from '../../../config';
import './ServitorReferral.css';

const DEFAULT_LIMIT = 10;

export default function ServitorReferral() {
  const navigate = useNavigate();
  const [rows,      setRows]       = useState([]);
  const [error,     setError]      = useState('');
  const [loading,   setLoading]    = useState(false);
  const [searchTerm,setSearchTerm] = useState('');
  const [meta,      setMeta]       = useState({
    page:1, limit:DEFAULT_LIMIT, total:0, totalPages:1,
    search:'', sortBy:'id', sortDir:'ASC'
  });

  const fetchPage = async () => {
    setLoading(true);
    try {
      const adminToken = localStorage.getItem('adminToken');

      const { data } = await axios.get(`${URL}/admin/servitor-referral`, {
        headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
        params: {
          page : meta.page,
          limit: DEFAULT_LIMIT,
          search: searchTerm,
          sortBy: meta.sortBy,
          sortDir: meta.sortDir
        }
      });
      setRows(Array.isArray(data?.data) ? data.data : []);
      if (data.meta) setMeta(m => ({ ...m, ...data.meta }));
      setError('');
    } catch (err) {
      setError('Failed to load referral metrics.');
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPage();
    // eslint-disable-next-line
  }, [meta.page, meta.sortBy, meta.sortDir, searchTerm]);

  const handlePageChange = (pageNumber) => {
    setMeta(m => ({ ...m, page: pageNumber }));
  };

  const getPageItems = (total, current, maxButtons = 7) => {
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3)/2);
    let start = Math.max(2, current - siblings);
    let end   = Math.min(total - 1, current + siblings);
    if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));
    if (start > 2) pages.push('start-ellipsis');
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push('end-ellipsis');
    if (total > 1) pages.push(total);
    return pages;
  };

  return (
    <Container fluid className="servitorreferral-container">
      <Card className="servitorreferral-card">
        <Card.Body>
          <Card.Header className="servitorreferral-header">
            <h4 className="servitorreferral-title">Servitor Referral Metrics</h4>
          </Card.Header>

          {error && <Alert variant="danger">{error}</Alert>}

          <Row className="mb-3">
            <Col md={8}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by Servitor ID, Name, Mobile, Code"
                  value={searchTerm}
                  onChange={e => {
                    setSearchTerm(e.target.value);
                    setMeta(m => ({ ...m, page:1 }));
                  }}
                />
              </InputGroup>
            </Col>
            <Col md={4}>
              <Button onClick={() => {
                setMeta(m => ({
                  ...m,
                  sortBy:'totalEarned',
                  sortDir: m.sortDir==='ASC' ? 'DESC' : 'ASC',
                  page:1
                }));
              }}>
                Sort by Earnings {meta.sortBy==='totalEarned' ? (meta.sortDir==='ASC'?'↑':'↓') : ''}
              </Button>
            </Col>
          </Row>

          {loading ? (
            <div className="text-center"><Spinner animation="border" /></div>
          ) : (
            <Table striped bordered hover responsive className="servitorreferral-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Servitor ID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Referral Code</th>
                  <th>Invited</th>
                  <th>Qualified</th>
                  <th>Total Earned</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((s,i) => (
                  <tr key={s.id}>
                    <td>{i + 1 + (meta.page-1)*meta.limit}</td>
                    <td>{s.id}</td>
                    <td>{s.name}</td>
                    <td>{s.mobile}</td>
                    <td>{s.referralCode}</td>
                    <td>{s.invitedCount}</td>
                    <td>{s.qualifiedCount}</td>
                    <td>৳{s.totalEarned.toLocaleString()}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => navigate(`/admin/servitor-referral/${s.id}`)}
                      >
                        Details
                      </Button>
                    </td>
                  </tr>
                ))}
                {rows.length===0 && (
                  <tr><td colSpan={9} className="text-center">No data found.</td></tr>
                )}
              </tbody>
            </Table>
          )}

          <Pagination>
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={meta.page===1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(meta.page-1)}
              disabled={meta.page===1}
            />
            {getPageItems(meta.totalPages, meta.page).map((item, idx) =>
              item==='start-ellipsis' || item==='end-ellipsis'
                ? <Pagination.Ellipsis key={item+idx} disabled />
                : (
                  <Pagination.Item
                    key={item}
                    active={item===meta.page}
                    onClick={()=>handlePageChange(item)}
                  >
                    {item}
                  </Pagination.Item>
                )
            )}
            <Pagination.Next
              onClick={()=>handlePageChange(meta.page+1)}
              disabled={meta.page===meta.totalPages}
            />
            <Pagination.Last
              onClick={()=>handlePageChange(meta.totalPages)}
              disabled={meta.page===meta.totalPages}
            />
          </Pagination>

        </Card.Body>
      </Card>
    </Container>
  );
}
